import React from "react";
import styled from "styled-components";
import { resolveCSSDimensions } from "../utils/resolveCSSDimensions";

interface FormWrapperProps {
  width?: number | string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const StyledWrapper = styled.div<FormWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: ${({ width }) => resolveCSSDimensions(width)};
`;

export const FormWrapper: React.FC<FormWrapperProps> = ({
  width,
  children,
  style,
}) => {
  return (
    <StyledWrapper width={width} style={style}>
      {children}
    </StyledWrapper>
  );
};

export const FormTitle = styled.h2`
  margin: 0;
`;

export const FormDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${(props) => props.theme.palette.text.secondary};
`;
